import { type FC } from 'react';
import cn from 'classnames';
import { cubicBezier, motion } from 'framer-motion';

import { type LotteryTicketType } from '@/common/types/lottery';

import css from './styles.module.scss';

interface ActiveEffectProps {
  type: LotteryTicketType;
}

const ActiveEffect: FC<ActiveEffectProps> = ({ type }) => {
  const fillColors = {
    Silver: 'white',
    Gold: '#ffd600',
    Diamond: '#4F8BFF',
  };

  return (
    <motion.svg
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        ease: cubicBezier(0.34, 1.56, 0.64, 1),
        duration: 0.2,
      }}
      xmlns="http://www.w3.org/2000/svg"
      width="107"
      height="40"
      viewBox="0 0 107 40"
      fill="none"
      className={cn(css.activeNavItem)}
    >
      <g filter="url(#filter0_f_40364_11217)">
        <ellipse cx="53" cy="48" rx="30" ry="16" fill={fillColors[type]} />
      </g>
      <defs>
        <filter
          id="filter0_f_40364_11217"
          x="-9"
          y="0"
          width="124"
          height="96"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="16"
            result="effect1_foregroundBlur_40364_11217"
          />
        </filter>
      </defs>
    </motion.svg>
  );
};

export { ActiveEffect };
